/* unplugin-vue-components disabled */import script from "./Age.vue?vue&type=script&setup=true&lang=js"
export * from "./Age.vue?vue&type=script&setup=true&lang=js"

import "./Age.vue?vue&type=style&index=0&id=5f8a215f&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f8a215f"]])

export default __exports__